import React, { Suspense, useRef } from "react";
import { useSelector } from "react-redux";
import BarSection from "@/components/rebrand/barSection";
import Header from "@/components/organisms/Header";
import Footer from "@/components/organisms/Footer";
import {
  HERO_MODEL,
  GOALS_MODEL,
  COVERAGE_MODEL,
  BANNER_MODEL,
  QUESTION_MODEL,
  FOOTER_MODEL,
} from "../models/model";
import SectionHero from "../components/SectionHero";
import useNearScreen from "@/hooks/useNearScreen";
import SectionGoals from "../components/SectionGoals";
import SectionCoverage from "../components/SectionCoverage";

const PdfLegal = React.lazy(() =>
  import("../../../../components/rebrand/questionSection/pdfLegal")
);
const SectionQuestion = React.lazy(() =>
  import("../components/SectionQuestions")
);

const SectionLazy = ({ isEmbedded }) => {
  const { isNearScreen, elementRef } = useNearScreen("30px");
  const sectionRef = useRef(false);

  if (isNearScreen) {
    sectionRef.current = isNearScreen;
  }

  return (
    <div
      ref={(ref) => (elementRef.current = ref)}
      id="section-lazy-coverage"
      style={{ minHeight: "500px" }}
    >
      <Suspense
        fallback={
          <div className="rbr__pre-img" style={{ textAlign: "center" }}>
            <div />
          </div>
        }
      >
        {sectionRef.current ? (
          <>
            <SectionQuestion {...QUESTION_MODEL} />
            <div className="rbr-section primary-bg o-hidden">
              <div className="rbr-container">
                <PdfLegal />
              </div>
            </div>
            {!isEmbedded && <Footer {...FOOTER_MODEL} />}
          </>
        ) : null}
      </Suspense>
    </div>
  );
};

const StepInitial = () => {
  const { isEmbedded } = useSelector((state) => state.embeddedReducer);

  return (
    <div className="rbr-section primary-bg o-hidden">
      {!isEmbedded && <Header backGround="ride-sys-color-background-subtle" />}
      <SectionHero {...HERO_MODEL} />
      <SectionGoals {...GOALS_MODEL} />
      <SectionCoverage authoring={COVERAGE_MODEL} />
      <div className="rbr-section background-gradient-primary o-hidden">
        <BarSection authoring={BANNER_MODEL} />
      </div>
      <SectionLazy isEmbedded={isEmbedded} />
    </div>
  );
};

export default StepInitial;
